module.exports = __webpack_public_path__ + "static/media/BebasNeue.95656079.otf";